import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
function Modal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-1">
      <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-2">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200" data-id="element-3">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-4">{title}</h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100 transition-colors" aria-label="Cerrar" data-id="element-5">
            <XIcon className="w-5 h-5 text-gray-500" data-id="element-6" />
          </button>
        </div>
        <div className="px-6 py-6 overflow-y-auto max-h-[65vh] text-gray-700 text-sm leading-relaxed space-y-4" data-id="element-7">
          {children}
        </div>
      </div>
    </div>;
}
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-[#1B2A4A] border-t border-white/10 py-12 md:py-16 px-4" data-id="element-8">
        <div className="max-w-4xl mx-auto flex flex-col items-center justify-center text-center space-y-8" data-id="element-9">
          <div className="space-y-3" data-id="element-10">
            <h3 className="text-3xl md:text-4xl font-extrabold text-white tracking-tight" data-id="element-11">
              Juega Desde Otro Nivel
            </h3>
            <p className="text-lg md:text-xl text-gray-400 italic" data-id="element-12">
              Vende mejor, con menos desgaste.
            </p>
          </div>

          <div className="flex items-center gap-8" data-id="element-13">
            <button onClick={() => setShowPrivacy(true)} className="text-gray-300 underline underline-offset-4 hover:text-white transition-colors text-sm md:text-base" data-id="element-14">
              Política de Privacidad
            </button>
            <button onClick={() => setShowTerms(true)} className="text-gray-300 underline underline-offset-4 hover:text-white transition-colors text-sm md:text-base" data-id="element-15">
              Términos y Condiciones
            </button>
          </div>

          <div className="pt-4 border-t border-white/10 w-full max-w-md" data-id="element-16">
            <p className="text-sm text-gray-500" data-id="element-17">
              © {new Date().getFullYear()} Juega Desde Otro Nivel. Todos los
              derechos reservados.
            </p>
          </div>
        </div>
      </footer>

      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-18">
        <p data-id="element-19">
          <strong data-id="element-20">Juega Desde Otro Nivel</strong> se compromete a proteger tu
          privacidad. Esta política describe cómo recopilamos, usamos y
          protegemos tu información personal.
        </p>
        <p data-id="element-21">
          <strong data-id="element-22">Información que recopilamos:</strong> Cuando completas
          nuestros formularios, podemos recopilar tu nombre, dirección de correo
          electrónico, número de teléfono y cualquier otra información que
          decidas proporcionarnos voluntariamente.
        </p>
        <p data-id="element-23">
          <strong data-id="element-24">Uso de la información:</strong> Utilizamos tu información
          personal para enviarte el material solicitado (como el Mapa de Gestión
          de Tiempo), comunicarnos contigo sobre nuestros servicios y mejorar tu
          experiencia.
        </p>
        <p data-id="element-25">
          <strong data-id="element-26">Protección de datos:</strong> Implementamos medidas de
          seguridad técnicas y organizativas para proteger tu información
          personal contra acceso no autorizado, pérdida o alteración.
        </p>
        <p data-id="element-27">
          <strong data-id="element-28">Compartir información:</strong> No vendemos, intercambiamos ni
          transferimos tu información personal a terceros sin tu consentimiento,
          excepto cuando sea necesario para cumplir con la ley.
        </p>
        <p data-id="element-29">
          <strong data-id="element-30">Tus derechos:</strong> Tienes derecho a acceder, rectificar o
          eliminar tu información personal en cualquier momento. Para ejercer
          estos derechos, contáctanos directamente.
        </p>
        <p data-id="element-31">
          <strong data-id="element-32">Cookies:</strong> Nuestro sitio puede utilizar cookies para
          mejorar la experiencia del usuario. Puedes configurar tu navegador
          para rechazar cookies si lo prefieres.
        </p>
        <p data-id="element-33">
          Esta política puede actualizarse periódicamente. Te recomendamos
          revisarla regularmente.
        </p>
      </Modal>

      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-34">
        <p data-id="element-35">
          Al acceder y utilizar este sitio web de{' '}
          <strong data-id="element-36">Juega Desde Otro Nivel</strong>, aceptas cumplir con los
          siguientes términos y condiciones.
        </p>
        <p data-id="element-37">
          <strong data-id="element-38">Uso del sitio:</strong> Este sitio web y su contenido son
          proporcionados con fines informativos y educativos. El material
          descargable está diseñado como herramienta de autodiagnóstico y no
          constituye asesoría profesional personalizada.
        </p>
        <p data-id="element-39">
          <strong data-id="element-40">Propiedad intelectual:</strong> Todo el contenido de este
          sitio, incluyendo textos, gráficos, logotipos, imágenes y materiales
          descargables, es propiedad de Juega Desde Otro Nivel y está protegido
          por las leyes de propiedad intelectual.
        </p>
        <p data-id="element-41">
          <strong data-id="element-42">Material descargable:</strong> El Mapa de Gestión de Tiempo y
          cualquier otro material proporcionado es para uso personal y no
          comercial. No está permitido redistribuir, vender o modificar estos
          materiales sin autorización previa.
        </p>
        <p data-id="element-43">
          <strong data-id="element-44">Limitación de responsabilidad:</strong> Los resultados
          obtenidos al utilizar nuestras herramientas pueden variar según cada
          persona. No garantizamos resultados específicos derivados del uso de
          nuestros materiales o servicios.
        </p>
        <p data-id="element-45">
          <strong data-id="element-46">Comunicaciones:</strong> Al proporcionar tu información de
          contacto, aceptas recibir comunicaciones relacionadas con nuestros
          servicios. Puedes darte de baja en cualquier momento.
        </p>
        <p data-id="element-47">
          <strong data-id="element-48">Modificaciones:</strong> Nos reservamos el derecho de
          modificar estos términos en cualquier momento. Los cambios entrarán en
          vigor inmediatamente después de su publicación en el sitio.
        </p>
        <p data-id="element-49">
          Para cualquier consulta sobre estos términos, no dudes en
          contactarnos.
        </p>
      </Modal>
    </>;
}